import * as React from 'react';
import { IgcToggleButtonComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * The `igc-toggle-button` wraps a native button element and exposes additional `value` and `selected` properties.
 * It is used in the context of an `igc-button-group` to facilitate the creation of group/toolbar like UX behaviors.
 * @slot Renders - the label/content of the button.
 * @csspart toggle - The native button element.
 * @class
 */
export const IgrToggleButton = /* @__PURE__ */ createComponent({
  tagName: 'igc-toggle-button',
  displayName: 'IgrToggleButton',
  elementClass: Component,
  react: React,
});

export type IgrToggleButton = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrToggleButtonModule = Component;
